import type { AiChecklistStatus } from '@/features/city-clerk/shared/types/ai-types'

export interface AiStatusAccent {
  accentColor: string
  accentPillBg: string
  accentPillText: string
}

export const AI_STATUS_ACCENT: Record<AiChecklistStatus, AiStatusAccent> = {
  fail: {
    accentColor: '#EF4444',
    accentPillBg: '#fee2e2',
    accentPillText: '#b91c1c',
  },
  pass: {
    accentColor: '#22C55E',
    accentPillBg: '#dcfce7',
    accentPillText: '#15803d',
  },
  warn: {
    accentColor: '#F59E0B',
    accentPillBg: '#fef3c7',
    accentPillText: '#b45309',
  },
  human_review: {
    accentColor: '#8B5CF6',
    accentPillBg: '#ede9fe',
    accentPillText: '#6d28d9',
  },
}

export function normalizeAiStatus(raw?: string | null): AiChecklistStatus {
  const s = (raw ?? '').toUpperCase().trim()
  if (s === 'PASS') return 'pass'
  if (s === 'FAIL') return 'fail'
  if (s === 'HUMAN_REVIEW') return 'human_review'
  return 'warn'
}
